import { GET_TRYST_HOST } from "../constants/env";

export default async function getBusinessPatientRelation({
  patientOid,
}: {
  patientOid: string;
}): Promise<{
  success: boolean;
  data?: DoctorPatientRelationType;
}> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${TRYST_HOST}/business/relation/${patientOid}`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    console.error(error);
    return {
      success: false,
    };
  }
}

export type DoctorPatientRelationType = {
  doctor_oid: string;
  patient_oid: string;
  patient_uuid: string;
  next_aid: string | null;
  last_aid: string | null;
  patient_connected: boolean;
  total_visits: number;
  amount_pending: number;
  amount_collected_over_time: number;
  source: DoctorPatientRelationSource;
  created_at: Date;
  updated_at: Date;
};

export const DoctorPatientRelationSource = {
  ANDROID_PATIENT_DISCOVERY: "ANDROID_PATIENT_DISCOVERY",
  IOS_PATIENT_DISCOVERY: "IOS_PATIENT_DISCOVERY",
  APPOINTMENT: "APPOINTMENT",
  JUGAAD: "JUGAAD",
  SYSTEM: "SYSTEM",
  REQUEST_REVIEW: "REQUEST_REVIEW",
};

export type DoctorPatientRelationSource =
  (typeof DoctorPatientRelationSource)[keyof typeof DoctorPatientRelationSource];
